export default __webpack_public_path__ + "b6858c64692a27ba205fdebf7dab4526.jpg";